import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function MSListPortalAdminMembers({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/portal-administration/members/managing-portal-members'}
                onClick={handleDrawerToggle}
                secondary={'Managing Portal Members'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/portal-administration/members/import-export-member-details'}
                onClick={handleDrawerToggle}
                secondary={'Importing Member Details'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/portal-administration/members/managing-member-groups'}
                onClick={handleDrawerToggle}
                secondary={'Managing Member Groups'}
            />
        </List>
    );
}

MSListPortalAdminMembers.propTypes = {
    classes: PropTypes.object.isRequired,
    handleDrawerToggle: PropTypes.func,
    onActive: PropTypes.func,
};

export default MSListPortalAdminMembers;
